import gsap from 'gsap'

function bannerParallax() {
    const parallax = document.querySelectorAll(
        '[data-target="parallax-illustration"]'
    )
    const img = document.querySelectorAll(
        '[data-target="parallax-illustration"] svg'
    )

    let speed

    if (img.length > 0) {
        img.forEach((img, index) => {
            if (parallax[index].getAttribute('data-speed')) {
                speed = parallax[index].getAttribute('data-speed')
            } else {
                speed = 0.02
            }
            setParallax(img)
        })

        function setParallax(img) {
            gsap.to(img, {
                duration: 1,
                delay: 0.5,
                opacity: 1,
            })

            const height = img.getBoundingClientRect().height

            if (window.innerWidth > 768) {
                img.style.height = height * 2.25 + 'px'
            } else if (window.innerWidth > 1280) {
                img.style.height = height * 1.25 + 'px'
            }

            img.style.width = '100%'
            const fg = img.getElementById('Layer-1')
            const mg = img.getElementById('Layer-2')
            const bg = img.getElementById('Layer-3')

            const elements = img.querySelectorAll('g')

            elements.forEach((el, index) => {
                el.style.transform = `translateY(${5}px)`

                if (speed) {
                    window.addEventListener('scroll', () => {
                        if (fg) {
                            const movementFg = -index * speed
                            const translateFg = movementFg * window.scrollY

                            fg.style.transform = `translateY(${translateFg}px)`
                        }

                        if (mg) {
                            const movementMg = -index * speed * 0.25
                            const translateMg = movementMg * window.scrollY

                            mg.style.transform = `translateY(${translateMg}px)`
                        }

                        if (bg) {
                            const movementBg = index * speed * 0.5
                            const translateBg = movementBg * window.scrollY

                            bg.style.transform = `translateY(${translateBg}px)`
                        }
                    })
                }
            })
        }
    }
}

export default bannerParallax
